import React from 'react'
import { IoIosQuote } from "react-icons/io";
import { FaThumbsUp } from "react-icons/fa6";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import './TestimonialSlide.css'

export const TestimonialSlide = (props) => {
    const { name,
        image,
        rating,
        date,
        review,
        likes,
        // link,
        source } = props.item;

    // Function to determine the number of filled stars and outline stars based on the rating
    const renderStars = (rating) => {
        const filledStars = Math.min(5, Math.max(0, Math.floor(rating)));
        const outlineStars = Math.max(0, 5 - filledStars);

        return (
            <>
                {Array(filledStars).fill().map((_, i) => (
                    <span className='star' key={i}>
                        <AiFillStar />
                    </span>
                ))}
                {Array(outlineStars).fill().map((_, i) => (
                    <span className='star' key={filledStars + i}>
                        <AiOutlineStar />
                    </span>
                ))}
            </>
        );
    };

    return (
        // <a href={link} target="_blank" rel="noreferrer">
        <div className='slide-container'>
            <div className='slide-header'>
                <span className='quote'><IoIosQuote /></span>
                <div>
                    {renderStars(rating)}
                </div>
            </div>
            <div className='slide-body'>
                {review}
            </div>
            <div className='slide-footer'>
                {image

                    ?
                    <img src={image} alt={name} />
                    :
                    <div className='no-image'>{name.charAt(0)}</div>
                }

                <div className="details">
                    <div className='footer-name'>{name}</div>
                    <p>{date?.toDateString()} {source && "| " + source} </p>

                </div>
                <div className='likesContainer'>
                    <FaThumbsUp size={30} />
                    <p>{likes}</p>
                </div>
            </div>
        </div>
        // </a>
    )
}
